import React, { createContext, useContext, useState } from "react";
import { MenuCtxType } from "../models/context";


const loadindDefault: MenuCtxType = {
  openMenu: false,
  setOpenMenu: () => {},
};

const MenuContext = createContext<MenuCtxType>(loadindDefault);

const MenuProvider = ({ children }: { children: React.ReactNode }) => {
  const [openMenu, setMenu] = useState<boolean>(false);

  const setOpenMenu = (param: boolean) => {
    setMenu(param);
  };

  return (
    <MenuContext.Provider
      value={{
        openMenu,
        setOpenMenu,
      }}
    >
      <span>{children}</span>
    </MenuContext.Provider>
  );
};

const useMenu = () => {
  const context = useContext(MenuContext);

  if (!context) throw new Error("useMenu must be used inside a `MenuProvider`");
  return context;
};

export { MenuProvider, useMenu };